import { ArticleHeading4, Button, UIText1 } from '@cian/ui-kit';
import { IconActionReload16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './SubAgentsError.css';

type TSubAgentsError = {
  onClick: () => void;
};

export const SubAgentsError: React.FC<TSubAgentsError> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['text']}>
        <ArticleHeading4>Список сотрудников не загрузился</ArticleHeading4>
        <UIText1 color="text-secondary-default">Попробуйте обновить</UIText1>
      </div>
      <Button
        size="XS"
        theme="stroke_primary"
        onClick={onClick}
        beforeIcon={<IconActionReload16 color="icon-main-default" />}
      >
        Обновить
      </Button>
    </div>
  );
};
